import React, { ReactNode } from 'react';
import { Card } from 'react-bootstrap';

const LicenseCard = (props: {
  title: string;
  children: ReactNode;
  action: ReactNode;
}) => {
  const { title, children, action } = props;

  return (
    <Card className="license-card">
      <Card.Body>
        <Card.Title>{title}</Card.Title>

        <Card.Text as="div">
          {children}
        </Card.Text>

        {
          action
        }
      </Card.Body>
    </Card>
  )
}

export default LicenseCard;
